import React from 'react'
import { DocumentTitle } from '../../components/DocumentTitle/DocumentTitle';
import CLInfoPanel from './CLInfoPanel';
import CLDetailsChart from './CLDetailsChart';
import RelatedCLData from './RelatedCLData';
import { Button, Tabs, Tooltip } from '@sede-enterprise/shell-ds-react-framework';
import { ChevronRight } from '@sede-enterprise/shell-ds-react-framework/build/esm/components/Icon/components';
import { DEFAULT_METRIC_SPEC } from '../../util/constants';
import { useMetricChartHook } from '../../components/MetricChart/useMetricChartHook';

const CLDetailsScreen = ({ units, prodUnit, corrosionLoopID, equipmentId, site, location }) => {
    const {
        data,
        metricData,
        loading,
        start,
        setStart,
        end,
        setEnd,
        interval,
        setSelectedInterval,
        intervalOpts,
        setRequestParams,
        formDirty,
        refreshChartData,
        refreshScatterData,
        scaled,
        setScaled
    } = useMetricChartHook(DEFAULT_METRIC_SPEC);
    return (
        <>
            <DocumentTitle title={`CARMA - Corrosion Loop ${corrosionLoopID}`} />
            <div className='parent-container'>
                <div className='content-container'>
                    <div className='details-title'>
                        <h4>Equipment: {equipmentId?.length > 13 ? <Tooltip className='remanent-tooltip' placement='bottom'
                            overlay={<div className='tooltip-content'>{equipmentId}</div>}
                            trigger={<Button style={{ padding: "0px" }} variant='transparent' onClick={() => { }}>{equipmentId?.substring(0, 13)}...</Button>} /> : equipmentId}</h4>
                        <ChevronRight />

                        <h4>CL:  {corrosionLoopID}</h4>
                    </div>
                    <Tabs tabBarStyle={{
                        justifyContent: 'flex-start',
                        // paddingLeft: '5%',
                        borderBottom: '1px solid #E0E0E0',
                        marginBottom: '20px'
                    }}
                        defaultActiveKey='features'
                        items={[
                            {
                                label: 'Details',
                                key: 'details',
                                children: <CLInfoPanel
                                    units={units}
                                    corrosionLoopID={corrosionLoopID}
                                    site={site}
                                    location={location} />
                            },
                            {
                                label: 'Features',
                                key: 'features',
                                children: <CLDetailsChart
                                    units={units}
                                    prodUnit={prodUnit}
                                    corrosionLoopID={corrosionLoopID}
                                    site={site}
                                    data={data}
                                    metricData={metricData}
                                    loading={loading}
                                    start={start}
                                    setStart={setStart}
                                    end={end}
                                    setEnd={setEnd}
                                    interval={interval}
                                    setSelectedInterval={setSelectedInterval}
                                    intervalOpts={intervalOpts}
                                    setRequestParams={setRequestParams}
                                    formDirty={formDirty}
                                    refreshChartData={refreshChartData}
                                    refreshScatterData={refreshScatterData}
                                    scaled={scaled}
                                    setScaled={setScaled}
                                    isRealSensor={location?.isRealSensor}
                                />
                            },
                            {
                                label: 'Related CL Data',
                                key: 'related',
                                children: <RelatedCLData
                                    units={units}
                                    corrosionLoopID={corrosionLoopID}
                                />
                            }

                        ]}
                    />
                </div>
            </div>
        </>
    )
}

export default CLDetailsScreen